import * as mutationTypes from "./mutation-types";
import { userService } from "./service";
import { getEmptyUser, getEmptySignInDetails, getEmptyMfaChallengeAttempt } from "./helpers";
import moment from "moment";

const canUseLocalStorage = typeof localStorage !== "undefined";
let storedUser = null;

try {
  storedUser = canUseLocalStorage ? JSON.parse(localStorage.getItem("user")) : null;
  
  if (storedUser) {
    const hasDataAccessToken = storedUser.tokenExpiresUtc ? true : false;
    if(hasDataAccessToken) {
      const expired = moment.utc(storedUser.tokenExpiresUtc).isBefore();
      if (expired) {
        storedUser = null;
      } else {
        userService.setAuthForAllAxiosRequests();
        userService.startAutomaticLogoutChecking();
      }
    }   
  } else {
    storedUser = null;
  }
} catch (e) {
  storedUser = null;
}

export const state = {
  user: {
    details: storedUser ? storedUser : getEmptyUser(),
    mfaChallengeAttempt: getEmptyMfaChallengeAttempt(),
    isSignedIn: storedUser ? true : false,
    busy: false,
    redirect: null,
    data: getEmptySignInDetails(),
    error: {
      show: false,
      details: {},
      hideMutation: mutationTypes.STATE_HIDE_ERROR,
      hideArgument: "user"
    }
  },
  widgets: {
    data: {},
    loading: false,
    loaded: false,
    processing: false
  }
};
